import { ToggleSurface } from "../../../../common/core/Surface";
import { useTranslation } from "react-i18next";
import { useMission } from "../../../../../providers/MissionProvider";
import MissionNotesSection from "../../../../common/sections/MissionNotesSection";

export default function MissionNotesCard() {
  const { t } = useTranslation();
  const { showMissionNotes } = useMission();

  return (
    <ToggleSurface
      title={t("mission:cards:missionNotes:title")}
      md={12} lg={6} collapse={!showMissionNotes}
    >
      {
        showMissionNotes ? (
          <MissionNotesSection />
        ) : null
      }
    </ToggleSurface>
  );
}
